// extracted by mini-css-extract-plugin
export var label = "_ej-2";
export var slideContainer = "_ej-0";
export var slider = "_ej-1";